export default __webpack_public_path__ + "static/media/card6.af42dcfd.png";